var _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccessReq(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 84,
    viewBox: "0 0 85 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4742_70575)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.7695 38.6504L62.9065 49.7873L51.7695 60.9243",
    stroke: "#08141E",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3766 49.6752L61.2016 49.6752",
    stroke: "#08141E",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3828 32.1996L12.2459 21.0627L23.3828 9.92578",
    stroke: "#08141E",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2439 21.0627L63.0373 21.0627",
    stroke: "#08141E",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.8964 74.4168C53.8964 74.4168 53.8964 74.4168 53.8964 74.4168C53.8963 74.4168 53.8963 74.4168 53.8963 74.4168L40.6838 61.3187C39.1054 59.7539 39.1054 57.2023 40.6838 55.6375C42.243 54.0918 44.7567 54.0918 46.3158 55.6375L53.4052 62.6656C54.9645 64.2113 57.4782 64.2113 59.0375 62.6656L75.6879 46.1593C77.2471 44.6136 79.7607 44.6136 81.3199 46.1593C82.8983 47.7241 82.8983 50.2756 81.3199 51.8404L57.3874 75.5658C56.7418 76.2058 55.701 76.2058 55.0554 75.5658L53.8964 74.4168Z",
    fill: "url(#paint0_radial_4742_70575)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_4742_70575",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(43.6714 50.3026) rotate(37.488) scale(48.9718 47.3845)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3FFF69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.442708,
    stopColor: "#2FFFB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03C3FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4742_70575"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 63,
    height: 63,
    fill: "white",
    transform: "translate(4.5 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessReq);
export default __webpack_public_path__ + "static/media/successReq.d9603bee5bd5e249cd893119696e3646.svg";
export { ForwardRef as ReactComponent };